import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { FiChevronLeft } from 'react-icons/fi'
import CatégorieService from '../../service/CatégorieService'
import '../styles/AdminForm.css'

const FormCatégorie = () => {
  const navigate = useNavigate()
  const authorization = localStorage.getItem('token')
  const [type] = useState(1)

  const [form, setForm] = useState({ name: '' })
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((f) => ({ ...f, [name]: value }))
    if (errors[name]) setErrors((err) => ({ ...err, [name]: null }))
  }

  const validate = () => {
    const err = {}
    if (!form.name.trim()) err.name = 'Le nom est requis'
    setErrors(err)
    return Object.keys(err).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) {
      document.querySelector('.ata-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }

    const data = { name: form.name, type }

    setSubmitting(true)
    try {
      await CatégorieService.ajouter(data, authorization)
      toast.success('Catégorie ajoutée avec succès')
      setTimeout(() => navigate('/admin/Catégorie'), 800)
    } catch (err) {
      toast.error("Échec de l'ajout")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="ata-page">
      <Toaster />

      <div className="ata-header">
        <button type="button" className="ata-back" onClick={() => navigate('/admin/Catégorie')}>
          <FiChevronLeft size={16} />
        </button>
        <div>
          <h1 className="ata-title">Ajouter une catégorie</h1>
          <p className="ata-subtitle">Renseignez les informations de la nouvelle catégorie</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ata-col-right" style={{ maxWidth: 640 }}>
          <div className="ata-card">
            <div className="ata-card__label">Informations générales</div>

            <div className="ata-field">
              <label>Nom *</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Ex: Salon"
                className={errors.name ? 'ata-input--error' : ''}
              />
              {errors.name && <p className="ata-error">{errors.name}</p>}
            </div>
          </div>
        </div>

        <div className="ata-footer-actions">
          <button type="button" className="ata-btn ata-btn--ghost" onClick={() => navigate('/admin/Catégorie')}>Annuler</button>
          <button type="submit" className="ata-btn ata-btn--primary" disabled={submitting}>
            {submitting ? (<><span className="ata-spinner" /> Enregistrement…</>) : 'Ajouter la catégorie'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default FormCatégorie
